/*
 *             Copyright (c) 2016 - 2021, CKSource - Frederico Knabben. All rights reserved.
 *
 *
 *
 *
 *          +---------------------------------------------------------------------------------+
 *          |                                                                                 |
 *          |                                 Hello stranger!                                 |
 *          |                                                                                 |
 *          |                                                                                 |
 *          |   What you're currently looking at is the source code of a legally protected,   |
 *          |    proprietary software. Any attempts to deobfuscate / disassemble this code    |
 *          |               are forbidden and will result in legal consequences.              |
 *          |                                                                                 |
 *          |                                                                                 |
 *          +---------------------------------------------------------------------------------+
 *
 *
 *
 *
 */
var _0x4591=['types','compress','shift','push'];(function(_0x1ced64,_0x45910c){var _0x420808=function(_0x3f3ce5){while(--_0x3f3ce5){_0x1ced64['push'](_0x1ced64['shift']());}};_0x420808(++_0x45910c);}(_0x4591,0xdd));var _0x4208=function(_0x1ced64,_0x45910c){_0x1ced64=_0x1ced64-0x0;var _0x420808=_0x4591[_0x1ced64];return _0x420808;};import _0x21418e from'./operationcompressor';export default class f extends _0x21418e{[_0x4208('0x0')](_0x182dac,_0x217634){_0x217634['shift'](),_0x182dac[_0x4208('0x3')][_0x4208('0x2')](this['id']);}['decompress'](_0x43312d,_0x26ae71){_0x26ae71['types'][_0x4208('0x1')](),_0x43312d[_0x4208('0x2')]({'__className':this['operationName']});}}